import styled from '@emotion/styled';

import { COLORS, FONT, SPACING } from '@zola/zola-ui/src/styles/emotion';

import { ButtonV2 } from '@zola/zola-ui/src/components/Button';

export const EmptyContainer = styled.div`
  background-color: ${COLORS.WHITE};
  border: 2px dashed ${COLORS.SCREAMING_GREY};
  width: 100%;
  border-radius: 4px;
  color: ${COLORS.EMPEROR};
  text-align: center;
  ${FONT.textSizeCompact(FONT.SIZE.SMALL)}
  padding: ${SPACING.S24} 16px;
  display: flex;
  align-items: center;
  text-align: left;
  margin-bottom: ${SPACING.MD};
`;

export const Tip = styled.div`
  margin-bottom: 0;
  margin-right: ${SPACING.MD};
`;

export const StyledButton = styled(ButtonV2)`
  margin-left: auto;
  flex-shrink: 0;
`;
